import styled, { css } from 'styled-components'
import checkGrey from '../Login/img-login/check-circle.png'
import checkGreen from '../Login/img-login/check-circle-green.png'

/* Tela toda branca, centralizada */
export const FullPageWrapper = styled.div`
  background-color: #ffffff;
  color: #1a1a1a;
  font-family: 'Roboto', system-ui, sans-serif;

  width: 100%;
  height: 100vh;

  display: flex;
  align-items: flex-start;
  justify-content: center;
  text-align: left;

  /* empurra um pouco pra baixo, igual no mock */
  padding-top: 40px;

  @media (max-width: 480px) {
    padding-top: 24px;
  }
`

/* Caixa de conteúdo, largura fixa */
export const Box = styled.div`
  width: 100%;
  max-width: 900px;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

/* Logo ordeno */
export const Logo = styled.img`
  max-height: 40px;
  width: auto;
  margin-bottom: 24px;
`

/* Título "Cadastre-se" */
export const Title = styled.h1`
  font-size: 1.4rem;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.3;
  margin: 0 0 8px 0;
  text-align: center;
`

/* Subtítulo cinza */
export const Subtitle = styled.p`
  font-size: 0.95rem;
  line-height: 1.4;
  color: #6b6b6b;
  margin: 0 0 24px 0;
  text-align: center;
  max-width: 480px;
`

/* Linha com 1 campo (100%) */
export const FormRowFull = styled.div`
  width: 100%;
  max-width: 800px;
  display: flex;
  flex-wrap: wrap;
  column-gap: 24px;
  row-gap: 16px;
  margin-bottom: 16px;
`

/* Linha com 2 campos lado a lado (50% / 50%) */
export const FormRowSplit = styled.div`
  width: 100%;
  max-width: 800px;
  display: flex;
  flex-wrap: wrap;
  column-gap: 24px;
  row-gap: 16px;
  margin-bottom: 16px;

  @media (max-width: 700px) {
    flex-direction: column;
  }
`

/* Cada campo individual (label + input) */
export const FieldGroup = styled.div`
  flex: 1;
  min-width: 260px;
  display: flex;
  flex-direction: column;
`

export const FieldLabel = styled.label`
  font-size: 0.9rem;
  font-weight: 500;
  color: #1a1a1a;
  margin-bottom: 6px;
`

/* Input comum (texto, email, tel, cnpj, empresa, etc.) */
export const InputField = styled.input`
  width: 100%;
  height: 44px;
  border-radius: 24px;
  border: 1px solid #cfcfcf;
  background-color: #efefef;
  padding: 0 14px;
  font-size: 0.9rem;
  color: #1a1a1a;

  &::placeholder {
    color: #9b9b9b;
  }
`

/* Campo de senha com ícone olho dentro */
export const PasswordFieldWrapper = styled.div`
  position: relative;
  width: 100%;
`

export const PasswordInput = styled.input`
  width: 100%;
  height: 44px;
  border-radius: 24px;
  border: 1px solid #cfcfcf;
  background-color: #efefef;
  padding: 0 44px 0 14px;
  font-size: 0.9rem;
  color: #1a1a1a;

  &::placeholder {
    color: #9b9b9b;
  }
`

export const PasswordToggle = styled.button`
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  border: 0;
  background: none;
  padding: 0;
  cursor: pointer;
  font-size: 0.9rem;
  color: #4a4a4a;
  line-height: 1;
`

/* Lista de requisitos da senha */
export const PasswordChecks = styled.div`
  width: 100%;
  max-width: 800px;
  margin-top: 8px;
  margin-bottom: 24px;

  display: flex;
  flex-direction: column;
  row-gap: 8px;
  font-size: 0.85rem;
  color: #6b6b6b;
`

export const PasswordCheckItem = styled.div<{ $ok: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  line-height: 1.4;
  font-size: 0.85rem;
  color: ${({ $ok }) => ($ok ? '#1a1a1a' : '#6b6b6b')};

  &::before {
    content: '';
    display: inline-block;
    width: 16px;
    height: 16px;
    background-image: url(${({ $ok }) => ($ok ? checkGreen : checkGrey)});
    background-size: contain;
    background-repeat: no-repeat;
    margin-top: 2px;
  }
`

/* Botão azul grandão "Cadastrar" */
export const SubmitButton = styled.button<{ disabled?: boolean }>`
  width: 100%;
  max-width: 800px;
  height: 44px;
  border: 0;
  border-radius: 24px;
  background-color: #007dc9;
  color: #ffffff;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    filter: brightness(0.95);
  }

  &:active {
    filter: brightness(0.9);
  }

  ${({ disabled }) =>
    disabled &&
    css`
      background-color: #ccc;
      cursor: not-allowed;
      &:hover {
        filter: none;
      }
      &:active {
        filter: none;
      }
    `};

  margin-bottom: 24px;
`

/* Link "← Voltar ao login" */
export const BackRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  color: #0072ce;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`

export const BackIcon = styled.span`
  font-size: 0.9rem;
  line-height: 1;
`

export const BackText = styled.span`
  font-size: 0.9rem;
  line-height: 1;
`
